import { createSlice } from '@reduxjs/toolkit';
import { fetchAnalysisChartData } from '../../services/dashboard/AnalysisChartService';

const initialState = {
  data: undefined,
  loading: false,
  error: undefined,
};

const AnalysisChartDataSlice = createSlice({
  name: 'analysisChartDataSlice',
  initialState,
  reducers: {
    setInitialState: (state) => {
      state.data = undefined;
      state.error = undefined;
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAnalysisChartData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAnalysisChartData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchAnalysisChartData.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { setInitialState } = AnalysisChartDataSlice.actions;

export default AnalysisChartDataSlice.reducer;
